import { useEffect, useState } from "react";
import { BellRing, X, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";

const place = (r, k) => [r[`${k}_area`], r[`${k}_region`], r[`${k}_country`]].filter(Boolean).join(", ") || t("Anywhere");
const label = (r) => [place(r, "loading"), "→", place(r, "offloading"), r.truck_type && `· ${t(r.truck_type)}`, r.commodity && `· ${t(r.commodity)}`].filter(Boolean).join(" ");

export default function SavedRoutes({ filters, onApply }) {
  const [routes, setRoutes] = useState([]);
  useEffect(() => { api.get("/routes").then((r) => setRoutes(r.data)).catch(() => {}); }, []);

  const canSave = ["loading_area", "offloading_area", "loading_country", "offloading_country", "loading_region", "offloading_region"].some((k) => (filters[k] || "").trim());
  const save = async () => {
    try {
      const { data } = await api.post("/routes", filters);
      setRoutes((r) => [data, ...r]);
      toast.success(t("Route saved — we'll email you when a matching load is posted"));
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (id) => {
    try { await api.delete(`/routes/${id}`); setRoutes((r) => r.filter((x) => x.id !== id)); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="hf-card p-4 mb-3" data-testid="saved-routes">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-slate-500"><BellRing className="w-3.5 h-3.5 text-amber-600" /> {t("Saved route alerts")}</p>
        <button disabled={!canSave} onClick={save} className="hf-btn-primary h-9 px-3 text-xs" data-testid="btn-save-route" title={canSave ? "" : t("Enter a loading or offloading area first")}>
          <Plus className="w-3.5 h-3.5" /> {t("Save current search")}
        </button>
      </div>
      {routes.length === 0 && <p className="text-xs text-slate-500 mt-2">{t("Set an area filter and save it — you'll get an email and notification the moment a matching load is posted.")}</p>}
      <div className="flex flex-wrap gap-2 mt-3">
        {routes.map((r) => (
          <span key={r.id} className="inline-flex items-center gap-1 h-8 pl-3 pr-1 rounded-full bg-slate-900 text-white text-xs" data-testid={`saved-route-${r.id}`}>
            <button onClick={() => onApply(r)} className="hover:text-amber-400 truncate max-w-[240px]" data-testid={`apply-route-${r.id}`}>{label(r)}</button>
            <button onClick={() => remove(r.id)} className="w-6 h-6 grid place-items-center rounded-full hover:bg-slate-700" data-testid={`delete-route-${r.id}`} aria-label={t("Delete route")}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
    </div>
  );
}
